export enum ECountry {
  POLAND = 'PL',
  OTHER = 'OTHER',
}
